<div class="row m-0 h-100 row-container"> 


  <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-admin-sidebar></app-admin-sidebar>
  </div>
  <div class="col-md-10 big-area p-0">

<div class="wrapperi">
    <div class="col-12 row mt-4">
        <div class="col-1"></div>
        <div class="col-10">
            <h2>Muokkaa ohjaustietoa</h2>
            <p>Tässä voit muokata ohjaustietoa. Kuluttajapuolen mainoskoko 1280x800 ja työnantajapuolen 616x820</p>

        </div>
        <div class="col-1"></div>
    </div>


  
  
    <div class="col-12 p-0 row m-0" *ngIf="routeID == 'opening-categories'">
      <div class="col-1"></div>
      <div class="col-12 mt-4 col-md-10 p-0 input-cover ">
        <button class="btn btn-formed-main-black mt-3 mb-3" (click)="addLine()"><i class="fas fa-plus-circle me-2"></i>Lisää rivi</button>
        <table class="table table-striped">
            <thead class="formed-table-header">
                <tr>
                    <th>Järjestysnumero</th>
                    <th>Nimi FI</th>
                    <th>Emoji</th>
                    <th>Hook</th>
                    <th>Poista</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let msg of this.paramList; let i = index">
                    <td><input spellcheck="true" (keyup)="updateText(i, 'order_number', 'input')" id="order_number-{{i}}" value="{{msg.order_number}}" class="form-control"/></td>
                    <td><input spellcheck="true" (keyup)="updateText(i, 'name_fi','input')" id="name_fi-{{i}}" value="{{msg.name_fi}}" class="form-control"/></td>
                    <td><input spellcheck="true" (keyup)="updateText(i, 'emoji','input')" id="emoji-{{i}}" value="{{msg.emoji}}" class="form-control"/></td>
                    <td *ngIf="hooks && hooks.length > 0">
                        <select class="form-control" id="hook-{{i}}" (change)="updateText(i, 'hook', 'select')">
                            <option value=""></option>
                            <option *ngFor="let hook of hooks" value="{{hook.id}}">{{hook.name_fi}}</option>
                        </select>
                    </td>
                    <td><button class="btn btn-formed-delete" (click)="removeLine(i)"><i class="far fa-trash-alt "></i></button></td>

                </tr>
            </tbody>
        </table>
        <button class="btn btn-formed-main-black" (click)="saveChanges()">Tallenna</button>
        </div>

        <div class="col-1"></div>
  </div>
  <div class="col-12 p-0 row m-0" *ngIf="routeID == 'banners' || routeID == 'banners-employer'">
    <div class="col-1"></div>
    <div class="col-12 mt-4 col-md-10 p-0 input-cover ">
      <button class="btn btn-formed-main-black mt-3 mb-3" (click)="addLine()"><i class="fas fa-plus-circle me-2"></i>Lisää rivi</button>
      <table class="table table-striped">
          <thead class="formed-table-header">
              <tr>
                <th>Kuva</th>
                  <th>Järjestysnumero</th>
                  <th>PVM alku</th>
                  <th>PVM loppu</th>
                  <th>URL</th>
                  <th>Tyyppi</th>
                  <th>Maa</th>
                  <th>Poista</th>
              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let msg of this.paramList; let i = index">
                    <td>
                        <ng-container *ngIf="!msg.image; else img_cont">
                            <input type="file" (change)="onFileChanged($event, i)" class="form-control"/>

                        </ng-container>
                        <ng-template #img_cont>
                            <img src="{{msg.image}}" width="100px" height="100px"/>
                        </ng-template>

                    </td>
                    <td><input spellcheck="true" (keyup)="updateText(i, 'order_number', 'input')" id="order_number-{{i}}" value="{{msg.order_number}}" class="form-control"/></td>

                    <td><input type="date" spellcheck="true" (change)="updateText(i, 'start_date', 'input')" id="start_date-{{i}}" value="{{msg.order_number}}" class="form-control"/></td>
                    <td><input type="date" spellcheck="true" (change)="updateText(i, 'end_date', 'input')" id="end_date-{{i}}" value="{{msg.order_number}}" class="form-control"/></td>
                    <td><input type="url" spellcheck="true" (change)="updateText(i, 'link', 'input')" id="link-{{i}}" value="{{msg.order_number}}" class="form-control"/></td>
                    <td>
                        <select class="form-control" id="banner_type-{{i}}" (change)="updateText(i, 'banner_type', 'select')">
                            <option value=""></option>
                            <option value="wish">635x896px (pysty)</option>
                            <option value="job">635x896px (vaaka)</option>
                        </select>
                      </td>
                  <td>
                    <select class="form-control" id="country_code-{{i}}" (change)="updateText(i, 'country_code', 'select')">
                        <option value=""></option>
                        <option value="FI">FI</option>
                    </select>
                  </td>
                  <td><button class="btn btn-formed-delete" (click)="removeLine(i)"><i class="far fa-trash-alt "></i></button></td>

              </tr>
          </tbody>
      </table>
      <button class="btn btn-formed-main-black" (click)="saveChanges()">Tallenna</button>
      </div>

      <div class="col-1"></div>
</div>

  </div>

    </div>